import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { CourseFilterCheckboxGroup } from './CourseFilterCheckboxGroup'
import { FilterDrawerType, FilterType, PriorityFilterValue } from './types'
import { CourseFilterAccordion } from '../CourseFilterAccordion/CourseFilterAccordion'

type Props = {
  type: FilterDrawerType
  onChange: (filterType: FilterType, value: PriorityFilterValue) => void
}

export const CourseFilterPriority = ({ type, onChange }: Props) => {
  const { t } = useTranslation()

  const filters = useAppSelector((state) => createFiltersSelector(state, type))

  return (
    <CourseFilterAccordion
      title={t('coursesFilterDrawer.coursePriority')}
      badgeCount={filters.coursePriority.length}
      testId="course-filter-priority"
    >
      <CourseFilterCheckboxGroup<PriorityFilterValue>
        filterType="coursePriority"
        options={[
          { label: t('coursesFilterDrawer.mandatory'), value: PriorityFilterValue.MANDATORY },
          { label: t('coursesFilterDrawer.optional'), value: PriorityFilterValue.OPTIONAL },
        ]}
        filters={filters}
        onChange={onChange}
      />
    </CourseFilterAccordion>
  )
}
